import {ICON_TYPES} from '../constants';

export const BedroomIcon = (): JSX.Element => {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3634_9097)'>
        <path
          d='M15.75 5H8.25C7.73329 5.00009 7.23235 5.17801 6.83136 5.50389C6.43037 5.82976 6.15375 6.28373 6.048 6.7895C5.68531 6.60181 5.28336 6.50261 4.875 6.5C4.17881 6.5 3.51113 6.77656 3.01884 7.26884C2.52656 7.76113 2.25 8.42881 2.25 9.125C2.2522 9.51501 2.34217 9.89951 2.51325 10.25H1.5V2H0V17H1.5V14.75H16.5V17H18V7.25C18 6.65326 17.7629 6.08097 17.341 5.65901C16.919 5.23705 16.3467 5 15.75 5ZM7.5 7.25C7.5 7.05109 7.57902 6.86032 7.71967 6.71967C7.86032 6.57902 8.05109 6.5 8.25 6.5H15.75C15.9489 6.5 16.1397 6.57902 16.2803 6.71967C16.421 6.86032 16.5 7.05109 16.5 7.25V10.25H7.5V7.25ZM3.75 9.125C3.75 8.9025 3.81598 8.68499 3.9396 8.49998C4.06321 8.31498 4.23891 8.17078 4.44448 8.08564C4.65005 8.00049 4.87625 7.97821 5.09448 8.02162C5.31271 8.06502 5.51316 8.17217 5.6705 8.3295C5.82783 8.48684 5.93498 8.68729 5.97838 8.90552C6.02179 9.12375 5.99951 9.34995 5.91436 9.55552C5.82922 9.76109 5.68502 9.93679 5.50002 10.0604C5.31501 10.184 5.0975 10.25 4.875 10.25C4.57663 10.25 4.29048 10.1315 4.0795 9.9205C3.86853 9.70952 3.75 9.42337 3.75 9.125ZM1.5 13.25V11.75H16.5V13.25H1.5Z'
          fill='#43494F'
        />
      </g>
      <defs>
        <clipPath id='clip0_3634_9097'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

BedroomIcon.iconType = ICON_TYPES.BEDROOM;
